import React from "react";
import { BodypartType } from "@growth-machine-llc/stridist-api-client";
import { BodypartTypeLabels } from "../constants";
import { GenericLibraryContextFilter } from "../../filters/GenericLibraryContextFilter";

export const BodypartFilter = React.memo(function BodypartFilter({
  onChange,
  contextFilters,
  className,
}: {
  onChange?: (selected: BodypartType[]) => void;
  contextFilters?: BodypartType[];
  className?: string;
}) {
  return (
    <GenericLibraryContextFilter
      enumType={BodypartType}
      filterTypesLabels={BodypartTypeLabels}
      labelType="Bodyparts"
      contextFilters={contextFilters}
      onChange={onChange}
      className={className}
    />
  );
});
